export default function (
    state: SurveyState = { loading: true, surveys: [], uom: {} },
    event: SurveyEvent
): SurveyState {
    switch (event?.type) {
        case 'start':
            return {
                loading: true,
                asset: event.events.info.asset,
                uid: event.events.info.uid,
                uom: event.events.info.uom,
                surveys: []
            }
        case 'event':
            return {
                ...state,
                loading: false,
                surveys: event.events
            }
    }

    return state
}
